import axios from '@fs/zion-axios'

export function getDynamicLinks() {
  return axios.get('/service/home/utils/chef/footer').then((response) => response.data)
}
